module.exports = __webpack_public_path__ + "static/media/SWSCRC6-20.5d1b883f.mp3";